import { Injectable } from '@angular/core';
import { LoadingController, AlertController } from 'ionic-angular';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/timeout';
import { ENV } from '@app/env';

const url_api = ENV.wp_domain+'/wp-json/';
const url_wp  = url_api+'wp/v2/';
const url_app = url_api+'app/v1/';

@Injectable()
export class WpApiProvider {

	active_requests = 0;
	loading;

	constructor(public http: Http, public loadCtrl: LoadingController, private alertCtrl: AlertController) {}
	
	makeGetRequest( url, keepLoading = false ) {
		return new Promise((resolve, reject) => {
			this._maybePresentLoader();
			keepLoading || this.active_requests++;
			this.http.get(url).map(res => res.json()).finally(() => {
				if (!keepLoading) {
					this.active_requests--;
					this._maybeDismissLoader();
				}
			}).timeout(15000).subscribe(
				data => {
					const callback = () => this._maybeDismissLoader();
					const result = keepLoading ? [data, callback] : data;
					resolve(result);
				},
				err => {
					let alert = this.alertCtrl.create({
						title: 'Ops!',
						subTitle: 'Prego, controllare la connessione ad internet e riprovare.',
						buttons: ['Chiudi']
					});
					alert.present();
					reject('Caricamento dati non riuscito.');
				}
			);
		});
	}

	makePostRequest( url, body ) {
		return new Promise((resolve, reject) => {
			this._maybePresentLoader();
			this.http.post(url, body).map(res => res.json())
				.finally(() => this._maybeDismissLoader())
				.timeout(15000)
				.subscribe(
					data => resolve(data),
					err  => {
						// console.log(err);
						reject(err);
					},
				);
		});
	}
	
	getPuntiRitiro() {
		return this.makeGetRequest(url_wp+'punto-ritiro?_embed&per_page=100');
	}
	
	getPuntoRitiro( id: number ) {
		return this.makeGetRequest(url_wp+'punto-ritiro/'+id, true);
	}

	getProdotti() {
		return this.makeGetRequest(url_wp+'prodotto?_embed&order=asc&per_page=100');
	}

	getCatProdotti() {
		return this.makeGetRequest(url_wp+'cat_prodotto?_embed&order=asc&per_page=100');
	}

	getPrezzi() {
		return this.makeGetRequest(url_app+'prezzi');
	}

	getPrezziPuntoRitiro( id: number ) {
		return this.makeGetRequest(url_app+'prezzi_punto/'+id);
	}

	getDispPuntoRitiro( id: number, keepLoading = true ) {
		return this.makeGetRequest(url_app+'punto-ritiro/disp/'+id, keepLoading);
	}

	postOrdine( data ) {
		return this.makePostRequest(url_app +'ordini/registra', data);
	}

	getAiutoPage() {
		return this.makeGetRequest(url_wp+'pages?slug=aiuto');
	}

	getOrdinamentoCategorieProdotti() {
		return this.makeGetRequest(url_app+'ordine_categorie_prodotti');
	}

	_maybePresentLoader() {
		if( !this.loading && !this.active_requests ) {
			this.loading = this.loadCtrl.create({ content: 'Caricamento...' });
			this.loading.present();
		}
		// console.log('aggiunto', this.active_requests);
	}

	_maybeDismissLoader() {
		// console.log(this.active_requests);
		if( !this.active_requests ) {
			this.loading.dismiss();
			this.loading = null;
		}
		// console.log('rimosso', this.active_requests);
	}

}


// WEBPACK FOOTER //
// ./src/providers/wp-api/wp-api.ts